import React from "react";
import {
  ShoppingCart,
  Phone,
  Package,
  X,
  CheckCircle,
  Clock,
  Send,
  Truck,
  RefreshCw,
} from "lucide-react";
import { OrderStats, User } from "./types";

interface KeyMetricsProps {
  stats: OrderStats | null;
  currentUser?: User;
}

const KeyMetrics: React.FC<KeyMetricsProps> = ({ stats, currentUser }) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
        {currentUser?.role === "country-post-manager" ? (
          // Shipping-focused metrics for post office managers
          <>
            <div className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <Package className="h-8 w-8 text-purple-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500">
                    Ready for Packaging
                  </p>
                  <p className="text-2xl font-semibold text-gray-900">
                    {stats?.byStatus?.[6] || 0}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <Send className="h-8 w-8 text-blue-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500">
                    Sent to Shipping
                  </p>
                  <p className="text-2xl font-semibold text-gray-900">
                    {stats?.byStatus?.[7] || 0}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <Truck className="h-8 w-8 text-yellow-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500">
                    In Transit
                  </p>
                  <p className="text-2xl font-semibold text-gray-900">
                    {stats?.byStatus?.[8] || 0}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <CheckCircle className="h-8 w-8 text-green-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500">Delivered</p>
                  <p className="text-2xl font-semibold text-gray-900">
                    {(stats?.byStatus?.[9] || 0) + (stats?.byStatus?.[10] || 0)}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <RefreshCw className="h-8 w-8 text-orange-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500">Returns</p>
                  <p className="text-2xl font-semibold text-gray-900">
                    {stats?.byStatus?.[25] || 0}
                  </p>
                </div>
              </div>
            </div>
          </>
        ) : (
          // Regular metrics for other roles
          <>
            <div className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <ShoppingCart className="h-8 w-8 text-blue-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500">
                    Total Orders
                  </p>
                  <p className="text-2xl font-semibold text-gray-900">
                    {stats?.total || 0}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <Phone className="h-8 w-8 text-orange-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500">
                    Callback Orders
                  </p>
                  <p className="text-2xl font-semibold text-gray-900">
                    {stats?.byStatus?.[3] || 0}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <Clock className="h-8 w-8 text-yellow-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500">
                    Processing Orders
                  </p>
                  <p className="text-2xl font-semibold text-gray-900">
                    {stats?.byStatus?.[2] || 0}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <Package className="h-8 w-8 text-purple-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500">Packaging</p>
                  <p className="text-2xl font-semibold text-gray-900">
                    {stats?.packagingOrders || 0}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <X className="h-8 w-8 text-red-600" />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500">Cancelled</p>
                  <p className="text-2xl font-semibold text-gray-900">
                    {stats?.byStatus?.[5] || 0}
                  </p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default KeyMetrics;
